// extracted by mini-css-extract-plugin
export var closeButton = "_hj-1";
export var closeX = "_hj-3";
export var container = "_hj-0";
export var image = "_hj-2";